export default {"src":"/_next/static/media/diamond_ring_40.27fa4402.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};